import * as React from 'react'

import { DocumentNode, TypedDocumentNode } from '@apollo/client'
import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'
import { ReviewProcessCustomTemplateDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { reviewTypePicker } from 'modules/performance_process/components/common/filters/reviewTypePicker'
import { Template } from 'modules/performance_process/components/templates/types'

import { QuestionnairePreview } from './questionnairePreview/QuestionnairePreview'

export const TemplatePreview: React.FC<{
  template: Template
  query: DocumentNode | TypedDocumentNode
}> = ({ template, query }) => {
  const { data, loading } = useQuery(query, {
    variables: {
      ids: [template.id],
    },
  })

  const isCustomTemplate = query === ReviewProcessCustomTemplateDocument
  const templateDetails = isCustomTemplate
    ? data?.performance?.reviewProcessCustomTemplatesConnection?.edges?.[0]?.node
    : data?.performance?.reviewProcessTemplatesConnection?.edges?.[0]?.node

  const templateQuestionnaire = isCustomTemplate
    ? templateDetails?.questionnaireByReviewerStrategies
    : templateDetails?.questionnaires

  const scoreConfiguration = isCustomTemplate && templateDetails?.scoreConfiguration

  return (
    <Box gap="s24">
      <Box gap="s12">
        <Text.Header2 weight="semibold">{template.name}</Text.Header2>
        <Text.Normal>
          {template.reviewerStrategies
            ? template.reviewerStrategies.map((type) => reviewTypePicker(type)).join(' | ')
            : '-'}
        </Text.Normal>
      </Box>
      {loading ? (
        <Skeleton isLoading height="full" />
      ) : (
        <Box gap="s16">
          <Text.Normal>{templateDetails?.templateDescription}</Text.Normal>
          <Box gap="s12">
            <QuestionnairePreview
              reviewType={template.reviewerStrategies ?? []}
              questionnaires={templateQuestionnaire ?? undefined}
              scoreConfiguration={scoreConfiguration}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}
